import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

var PHONE_NUMBER = "+7 (812) 313-98-98";
var PHONE_HREF = "tel:+78123139898";

export default function Header() {
  var [scrolled, setScrolled] = useState(false);
  var [menuOpen, setMenuOpen] = useState(false);

  useEffect(function () {
    var onScroll = function () { setScrolled(window.scrollY > 20); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return function () { window.removeEventListener("scroll", onScroll); };
  }, []);

  var scrollToQuiz = function () {
    setMenuOpen(false);
    var el = document.getElementById("quiz-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header"
      className={"fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 " + (scrolled ? "shadow-md" : "")}
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#/" data-testid="header-logo" className="flex items-center gap-2.5 max-w-[320px] lg:max-w-[420px]">
            <div className="w-9 h-9 rounded-xl bg-brand-600 flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm font-heading">НС</span>
            </div>
            <span className="hidden sm:block text-sm lg:text-base font-semibold leading-tight">
              Центр современной стоматологии и&nbsp;челюстно&#8209;лицевой хирургии
            </span>
          </a>

          <div className="hidden md:flex items-center gap-5">
            <a href={PHONE_HREF} data-testid="header-phone" className="flex items-center gap-2 text-lg font-semibold hover:text-brand-600 transition-colors">
              <Phone className="w-5 h-5 text-brand-600" />
              {PHONE_NUMBER}
            </a>
            <button
              data-testid="header-cta"
              onClick={scrollToQuiz}
              className="h-12 px-8 text-base font-medium rounded-full bg-brand-600 hover:bg-brand-700 text-white transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              Рассчитать стоимость
            </button>
          </div>

          <div className="flex md:hidden items-center gap-3">
            <a href={PHONE_HREF} data-testid="header-phone-mobile" className="w-10 h-10 rounded-full bg-brand-50 flex items-center justify-center">
              <Phone className="w-5 h-5 text-brand-600" />
            </a>
            <button
              data-testid="header-menu-toggle"
              onClick={function () { setMenuOpen(!menuOpen); }}
              className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center cursor-pointer"
            >
              {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {menuOpen && (
          <div data-testid="mobile-menu" className="md:hidden pb-4 border-t border-slate-100 animate-fade-in">
            <div className="flex flex-col gap-3 pt-4">
              <p className="text-sm font-semibold leading-tight">
                Центр современной стоматологии и&nbsp;челюстно&#8209;лицевой хирургии
              </p>
              <a href={PHONE_HREF} className="flex items-center gap-2 text-lg font-semibold py-2">
                <Phone className="w-5 h-5 text-brand-600" />
                {PHONE_NUMBER}
              </a>
              <button
                data-testid="mobile-menu-cta"
                onClick={scrollToQuiz}
                className="h-12 text-base font-medium rounded-full bg-brand-600 hover:bg-brand-700 text-white cursor-pointer"
              >
                Рассчитать стоимость
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
